import { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

import { registerLeaveGuard, unregisterLeaveGuard } from '../leaveGuardRegistry';

const useLeaveBlocker = (active) => {
    const [pendingLeave, setPendingLeave] = useState(null);
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            active && currentLocation.pathname !== nextLocation.pathname
    );
    const isPrompting = blocker.state === 'blocked' || pendingLeave !== null;

    const requestLeave = (callback) => {
        if (!active) {
            callback?.();
            return;
        }
        setPendingLeave(() => callback ?? null);
    };

    const proceed = () => {
        if (pendingLeave) {
            const callBack = pendingLeave;
            setPendingLeave(null);
            callBack();
        }
        if (blocker.state === 'blocked') {
            blocker.proceed();
        }
    };

    // USEEFFECTS

    useEffect(() => {
        if (!active) return undefined;
        const handler = (e) => {
            e.preventDefault();
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [active]);

    useEffect(() => {
        if (active) {
            registerLeaveGuard(requestLeave);
            return () => unregisterLeaveGuard();
        }
        unregisterLeaveGuard();
    }, [active, requestLeave]);


    return { isPrompting, proceed, requestLeave };
};

export default useLeaveBlocker;
